/*=========================================================================================
  File Name: moduleDeviceState.js
  Description: Device Module State
==========================================================================================*/

export default {
	todoList: [],
	totalTodoList: 0,
	devices: [],
	employees: [],
	limitPerPage: 10,
	moduleRoles: [],
	todolistCount: [],
	todoListChild: []
};
